import {
  ArrowUpRight,
  Envelope,
  Linkedin,
  Telephone,
} from "react-bootstrap-icons";
export const Contact = () => (
  <section
    className="contact-section page-shell"
    id="connect"
    aria-labelledby="contact-title"
  >
    <div className="contact-panel">
      <div>
        <p className="eyebrow">04 / Start a conversation</p>
        <h2 id="contact-title">
          Have something
          <br />
          <em>in mind?</em>
        </h2>
        <p>Let’s talk software, share an idea, or simply say hello.</p>
      </div>
      <div className="contact-options">
        <a href="mailto:zhang_zzaaron@hotmail.com">
          <Envelope aria-hidden="true" />
          <span>
            <small>Email me</small>zhang_zzaaron@hotmail.com
          </span>
          <ArrowUpRight aria-hidden="true" />
        </a>
        <a
          href="https://www.linkedin.com/in/aaron-zhang-29203349/"
          target="_blank"
          rel="noreferrer"
        >
          <Linkedin aria-hidden="true" />
          <span>
            <small>Connect on LinkedIn</small>Aaron Zhang
          </span>
          <ArrowUpRight aria-hidden="true" />
        </a>
        <a href="tel:+16137977756">
          <Telephone aria-hidden="true" />
          <span>
            <small>Give me a call</small>+1 (613) 797-7756
          </span>
          <ArrowUpRight aria-hidden="true" />
        </a>
      </div>
    </div>
  </section>
);
